import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function InputAddon(props: Props) {
  return <div>{props.children}</div>;
}
